var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskGaiaNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_9808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 17.3438H11.4062L6.65625 20.9062V17.3438H4.28125C3.96631 17.3438 3.66426 17.2187 3.44156 16.996C3.21886 16.7733 3.09375 16.4712 3.09375 16.1562V4.28125C3.09375 3.96631 3.21886 3.66426 3.44156 3.44156C3.66426 3.21886 3.96631 3.09375 4.28125 3.09375H19.7188C20.0337 3.09375 20.3358 3.21886 20.5585 3.44156C20.7812 3.66426 20.9062 3.96631 20.9062 4.28125V16.1562C20.9062 16.4712 20.7812 16.7733 20.5585 16.996C20.3358 17.2187 20.0337 17.3438 19.7188 17.3438Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5156C11.836 10.5156 11.7031 10.3827 11.7031 10.2188C11.7031 10.0548 11.836 9.92188 12 9.92188",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5156C12.164 10.5156 12.2969 10.3827 12.2969 10.2188C12.2969 10.0548 12.164 9.92188 12 9.92188",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.5156C8.27354 10.5156 8.14062 10.3827 8.14062 10.2188C8.14062 10.0548 8.27354 9.92188 8.4375 9.92188",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.5156C8.60146 10.5156 8.73438 10.3827 8.73438 10.2188C8.73438 10.0548 8.60146 9.92188 8.4375 9.92188",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 10.5156C15.3985 10.5156 15.2656 10.3827 15.2656 10.2188C15.2656 10.0548 15.3985 9.92188 15.5625 9.92188",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 10.5156C15.7265 10.5156 15.8594 10.3827 15.8594 10.2188C15.8594 10.0548 15.7265 9.92188 15.5625 9.92188",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_9808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskGaiaNew);
export default __webpack_public_path__ + "static/media/ASKGaiaNew.8e99b5f72c48962bc6ae8f24e9b9f0d5.svg";
export { ForwardRef as ReactComponent };